import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@app/services/login.service';
import { ValidaDocumento } from '@app/utils/valida-documento';
import { ValidaSenha } from '@app/utils/valida-senha';
import { ToastrService } from 'ngx-toastr';
import { timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { RedefinirSenhaModel } from './redefinir-senha.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html'
})
export class RedefinirSenhaComponent implements OnInit {

  validaDocumento: ValidaDocumento = new ValidaDocumento();
  validaSenha = ValidaSenha;
  
  producao: boolean = false;
  carregando: boolean = false;
  senhasIguais: boolean = true;
  linkExpirado: boolean = false;

  novaSenha: string = '';
  confirmacaoSenha: string = '';
  mensagemValidaSenha: string = '';

  private _rotaHash: string = '';
  private _rotaData: string = '';

  tempoRestante$;
  tempoRestante = 0;

  constructor(
    private loginService: LoginService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      (data) => {
        this._rotaHash = data["hashTemporaria"];
        this._rotaData = data["timeStampExpiracao"];
        this._comecaTimer();
      }
    )
    
    if (environment.PRODUCAO) {
      this.producao = true;
    }
  }

  private _comecaTimer() {
    let timeStampAtual = Math.round(new Date().getTime()/1000);
    let tempoTimer = Number(this._rotaData) - timeStampAtual;

    if(tempoTimer <= 5){
      this.toastr.error('Link expirado!');
      this.linkExpirado = true;
      return;
    }

    this.tempoRestante$ = timer(1000, 1000).pipe(
      map(n => tempoTimer - n),
      takeWhile(n => n >= 0)
    );

    this.tempoRestante$.subscribe(data => {
      this.tempoRestante = data * 1000
      if(data === 0){
        this.toastr.error('Link expirado!');
        this.linkExpirado = true;
      }
    });
  }

  onSubmit() {
    this.carregando = true;
    const redefinicao = new RedefinirSenhaModel(this._rotaHash, this.confirmacaoSenha);
    this.loginService.redefinirSenha(redefinicao).subscribe(
      () => {
        this.toastr.success("Senha modificada com sucesso!");
        this.router.navigate(["/login"]);
      },
      () => {
        this.toastr.error("Erro ao redefinir senha!");
        this.carregando = false;
      }
    );
  }

  validarSenha(){
    if(!this.validaSenha.validar(this.novaSenha))
      this.mensagemValidaSenha =  this.validaSenha.obterRequisitosNaoAtendidos(this.novaSenha);
    else
      this.mensagemValidaSenha = '';
  }

  compararSenhas(){
    this.senhasIguais = this.novaSenha === this.confirmacaoSenha;
  }

}
